var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook, Negative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0.673828C5.37264 0.673828 0 6.04647 0 12.6738C0 18.3013 3.87456 23.0236 9.10128 24.3205V16.341H6.62688V12.6738H9.10128V11.0937C9.10128 7.00935 10.9498 5.11623 14.9597 5.11623C15.72 5.11623 17.0318 5.26551 17.5685 5.41431V8.73831C17.2853 8.70855 16.7933 8.69367 16.1822 8.69367C14.2147 8.69367 13.4544 9.43911 13.4544 11.3769V12.6738H17.3741L16.7006 16.341H13.4544V24.586C19.3963 23.8684 24.0005 18.8092 24.0005 12.6738C24 6.04647 18.6274 0.673828 12 0.673828Z",
    fill: "#FAFAFA",
    fillOpacity: 0.72
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.5b8828c6b728f7acf47963d733910a52.svg";
export { ForwardRef as ReactComponent };